
import { Platform } from 'react-native';

export const firebaseConfig = {
  apiKey: "AIzaSyBA22uZfHg9PU7x_Ahm-vbSUwzuPHv0mbc",
  authDomain: "bowa-analytics.firebaseapp.com",
  projectId: "bowa-analytics",
  storageBucket: "bowa-analytics.firebasestorage.app",
  messagingSenderId: "504496547046",
  appId: "1:504496547046:web:e4c6294c19dd95e13a0727",
  measurementId: "G-02EBTT2LSY"
}; // test credentials

// export const firebaseConfig = {
//   apiKey: "AIzaSyDdUvRDW1eXo4lvBoJ4zWQOytID6La2Kpc",
//   authDomain: "svara-stage.firebaseapp.com",
//   projectId: "svara-stage",
//   storageBucket: "svara-stage.firebasestorage.app",
//   messagingSenderId: "1008298134506",
//   appId: "1:1008298134506:web:312d506c21084315cfc093",
//   measurementId: "G-TQF91XNVNS"
// };

export const isFirebaseEnabled = true;
//   process.env.NODE_ENV === 'production' || 
//   process.env.NEXT_PUBLIC_FIREBASE_ENABLED === 'true';

export const isWebPlatform = Platform.OS === 'web';
export const isMobilePlatform = Platform.OS === 'ios' || Platform.OS === 'android';